// removed by extract-text-webpack-plugin
module.exports = {"start-free-trial-modal":"start-free-trial-modal","classtop-modal-content":"classtop-modal-content","trail-section":"trail-section","section-title":"section-title","feature-title":"feature-title","check-icon":"check-icon","close-icon":"close-icon","section-description":"section-description","included-features":"included-features","btn-start-trial":"btn-start-trial"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/StartFreeTrial/Modal.scss
// module id = YrYI
// module chunks = 0